// nodemodule imports
import React from 'react';
import styled from "styled-components";

// project imports
import Example from "./Example";
import Description from "./Description";
import api_docs from "./../../../API_docs.json"

export default (({docs}) => {


  return (
    <>
      {api_docs.map((section, index) => (
        <Section id={section.title} key={index}>
          <Body>
            <Description section={section}/>
            <Example example={section.example} index={index}/>
          </Body>
        </Section>
      ))}
    </>
  )
})

const Body = styled.div(props => ({
  display: 'flex',
  "@media (max-width: 1080px)": {
    flexDirection:"column",
  },
}));

const Section = styled.div(props => ({
  padding: '50px 0 30px 0'
}));

